<template>
  <label class="ordering-counterparty__radio">
    <input
      type="radio"
      :checked="checked"
      @change="$emit('change', $event.target.value)"
    />
    <span class="ordering-counterparty__radio-state"></span>
    <slot />
  </label>
</template>

<script>
export default {
  name: "OrderingCounterpartyRadio",
  props: {
    checked: Boolean
  }
};
</script>

<style lang="scss">
.ordering-counterparty__radio {
  display: flex;
  align-items: center;
  color: var(--dark, #262626);
  font-feature-settings: "clig" off, "liga" off;
  font-size: 0.875rem;
  line-height: 22px;
  cursor: pointer;

  input {
    position: absolute;
    pointer-events: none;
  }

  input:checked + &-state:after {
    opacity: 1;
  }

  &-state {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border: 1px solid var(--gray-darker, #d5dae5);
    border-radius: 50%;
    margin-right: 10px;

    &:after {
      content: "";
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      opacity: 0;
      background: var(--main-dark, #005197);
      transition: var(--transition);
    }
  }
}
</style>
